import { render, staticRenderFns } from "./NotarySuccess.vue?vue&type=template&id=b7136d06"
import script from "./NotarySuccess.vue?vue&type=script&lang=js"
export * from "./NotarySuccess.vue?vue&type=script&lang=js"
import style0 from "./NotarySuccess.vue?vue&type=style&index=0&id=b7136d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports